import Icon from '../components/Icon.vue'

Icon.register({"map-signs":{"width":512,"height":512,"paths":[{"d":"M487.5 104.5L439 153A24-24 0 0 0 422.1 160H56C42.7 160 32 149.3 32 136V56C32 42.7 42.7 32 56 32H216V24C216 10.7 226.7 0 240 0H272C285.3 0 296 10.7 296 24V32H422.1A24-24 0 0 0 439 39L487.5 87.5C492.2 92.2 492.2 99.8 487.5 104.5zM216 368V488C216 501.3 226.7 512 240 512H272C285.3 512 296 501.3 296 488V368H216zM456 224H296V176H216V224H89.9A24-24 0 0 1 73 231L24.5 279.5C19.8 284.2 19.8 291.8 24.5 296.5L73 345A24-24 0 0 1 89.9 352H456C469.3 352 480 341.3 480 328V248C480 234.7 469.3 224 456 224z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/map-signs.js